import { useEffect } from "react";
import { useMap } from "react-leaflet";
import Locate from "leaflet.locatecontrol";

export default function LocateControl() {

  const map = useMap();

  useEffect(() => {

    // geo locate props
    const locateOptions = {
      position: 'topleft',
      maxZoom: 19,
      strings: {
          title: 'Standort anzeigen.'
      },
      onActivate: () => {} // callback before engine starts retrieving locations
    }

    const lc = new Locate(locateOptions);
    // console.log(lc);
    lc.addTo(map);

  }, [map]);

  return null;

}